import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon";

const Facebook: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="24"
            viewBox="0 0 14 24"
            fill="none"
        >
            <path d="M3.09375 14.0297V24H8.53125V14.0297H12.5859L13.4297 9.44531H8.53125V7.82344C8.53125 5.4 9.48281 4.47188 11.9391 4.47188C12.7031 4.47188 13.3172 4.49062 13.6734 4.52812V0.370313C13.0031 0.1875 11.3625 0 10.4156 0C5.40469 0 3.09375 2.36719 3.09375 7.47187V9.44531H0V14.0297H3.09375Z" 
                fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Facebook);
